import nexo from '@tiendanube/nexo';
import { config } from 'config';

const instance = nexo.create({
  clientId: config.nexo.clientId,
  log: config.nexo.debug,
});

export default instance;
